import clsx from "clsx";
import get from "lodash/get";
import React, { FC, useEffect, useMemo } from "react";
import { endOfMonth, getMonth, getYear } from "date-fns";
import { useForm } from "react-hook-form/dist/index.ie11";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

import Filter from "~/components/Filter";
import PanelWrapper from "~/components/PanelWrapper";
import DatesPicker from "~/shared/ui/Fields/DatePicker";
import { LANG } from "~/constans/commom";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { IQExcludedDatesList } from "~/pages/Q";
import { useGetDealerPanelQuery } from "~/schemas/generated/graphql";
import { useCurrentDealerId } from "~/shared/hooks/useCurrentDealerId";

import { DEALER_INFO, LOCALIZE_DEALER_INFO, RATINGS_TYPES } from "./options";

import s from "./DealerInfoPanel.less";

interface IDealerData {
  id?: string;
  DealerId?: string;
  DealerName?: string;
  DealerNameEn?: string;
  [key: string]: unknown;
}

interface IProps {
  type?: string;
  Dealer?: IDealerData;
  defaultDate?: string;
  width?: number;
  widthFilter?: number;
  allowDates?: IQExcludedDatesList;
}

const DealerInfoPanel: FC<IProps> = ({
  type,
  defaultDate,
  width,
  widthFilter,
  Dealer,
  allowDates,
}) => {
  const { t } = useTranslation();
  const isEn = localStorage.getItem("language") === LANG.en;
  const setData = useSetLocationData();
  const { event } = useGetLocationData();
  const sessionDealerId = useCurrentDealerId();
  const currentDealerId =
    type === "ZD"
      ? event || sessionDealerId
      : sessionDealerId;
  const { control, watch } = useForm();
  // Если Dealer передан через пропсы (например, на странице нарушения),
  // используем его ID — иначе currentDealerId из sessionStorage
  const dealerIdFromProp = Dealer?.id || Dealer?.DealerId;
  const { data } = useGetDealerPanelQuery({
    variables: {
      DealerId: dealerIdFromProp || currentDealerId,
    },
  });
  const dealerPanel = (Dealer ||
    (get(data, "DealerGetter.getDealer") as Record<string, unknown>) ||
    {}) as Record<string, string>;
  const { DealerName = "", DealerNameEn = "" } = dealerPanel;
  const qDate = watch("QDate");
  const history = useHistory();

  useEffect(() => {
    qDate && type === RATINGS_TYPES.q
      ? setData("selectedDate", endOfMonth(new Date(qDate)))
      : setData("selectedDate", qDate);
  }, [qDate]);

  const selectYearOptions = useMemo(() => {
    const currentYear = new Date().getFullYear();
    const result = [];
    for (let i = currentYear; i > currentYear - 10; i--) {
      result.push(String(i));
    }
    return result;
  }, []);

  const filterDate = (date: Date) => {
    const year = getYear(new Date(date));
    const month = getMonth(new Date(date)) + 1;
    const allowedMonth = allowDates[year] || [];

    return allowedMonth.includes(month);
  };

  return (
    <PanelWrapper width={width || 685} customClassName={s.text_center}>
      <div className={s.title}>{isEn ? DealerNameEn : DealerName}</div>
      <div className={s.s_dealer_select}>
        {(type === RATINGS_TYPES.q || type === RATINGS_TYPES.staff) && (
          <DatesPicker
            name={"QDate"}
            control={control}
            gray
            customClassName={clsx(s.date_q, {
              [s.date_staff]: type === RATINGS_TYPES.staff,
            })}
            dateFormat={"MM.yyyy"}
            defaultValue={defaultDate}
            showMonthYear
            filterDate={filterDate}
          />
        )}
        {type === RATINGS_TYPES.zd && (
          <DatesPicker
            name={"QDate"}
            control={control}
            gray
            customClassName={s.date_q}
            dateFormat={"dd.MM.yyyy"}
            defaultValue={defaultDate}
          />
        )}
        {type === RATINGS_TYPES.gr && (
          <Filter width={widthFilter} isYear options={selectYearOptions} />
        )}
      </div>

      {DEALER_INFO.map((InfoPanel, i) => {
        const currentOption =
          LOCALIZE_DEALER_INFO.includes(InfoPanel) && isEn
            ? `${InfoPanel}En`
            : InfoPanel;
        return (
          <div className={s.text} key={i}>
            {t(`dealerPanel.${InfoPanel}`)}
            <br />
            <b>{dealerPanel[currentOption]}</b>
          </div>
        );
      })}
    </PanelWrapper>
  );
};

export default DealerInfoPanel;
